/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */
import { USER } from '@/store/types';
import * as api from '@/api/user';
import { UserFull } from '@/api/types/user';

export interface StoreUserFindState {
  user?: UserFull;
  point: number;
  noMore: boolean;
}

export default {
  namespaced: true,
  state: {
    user: null,
    point: null,
    noMore: false,
  },
  actions: {
    [USER.FIND]({ commit, state }, params) {
      if (params.next) {
        params.body.point = params.reload ? null : state.point;
      } else if (state.user) {
        return Promise.resolve();
      }
      return new Promise((resolve, reject) => {
        api.findUser(params.body).then((res) => {
          commit(USER.FIND, res.data);
          resolve();
        }).catch(reject);
      });
    },
  },
  mutations: {
    [USER.FIND](state, user) {
      state.user = user;
      state.point = user && user.timeViewAll;
      state.noMore = !user;
    },
  },
};
